import React, { useRef, useState, useEffect } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { Button, Grid, Typography } from "@material-ui/core";
import dropImage from "../../images/DropImage.svg";
import { filter, range } from "lodash";
import GDPDroppable from "../GDPDroppable";
import DraggableAnswer from "../DraggableAnswer";
import "animate.css/animate.css";

const PlayQuiz = (props) => {
  const {
    classes,
    dragStarted,
    setDragStarted,
    onSubmit,
    currentQuestion,
    answers,
    answeredCorrectly,
    setAnsweredCorrectly,
    prevQuestion,
    prevAnswer
  } = props;

  const [inYes, setInYes] = useState(false);
  const [inNo, setInNo] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  // const [currentPosition, setCurrentPosition] = useState({ x: 0, y: 0 })
  const [answered, setAnswered] = useState(false);
  const [dragChildStarted, setDragChildStarted] = useState(false);
  const [showDropIconSection, setShowDropIconSection] = useState(false);

  const yesRef = useRef(null);
  const noRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setShowDropIconSection(true), 800);
  }, []);

  const onDragUpdate = (e) => {
    if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        yesRef.current
      )
    ) {
      setInYes(true);
    } else if (
      checkIfInAnyBox(
        e.pageX || e.changedTouches[0].pageX,
        e.pageY || e.changedTouches[0].pageY,
        noRef.current
      )
    ) {
      setInNo(true);
    } else {
      setInYes(false);
      setInNo(false);
    }
  };

  const checkIfInAnyBox = (x, y, element) => {
    let targetX = element.offsetLeft;
    let targetY = element.offsetTop;
    let targetHeight = element.offsetHeight;
    let targetWidth = element.offsetWidth;
    return (
      x >= targetX &&
      x <= targetX + targetWidth &&
      y >= targetY &&
      y < targetY + targetHeight
    );
  };

  const onDragStart = (e) => {
    setDragStarted(true);
  };

  const ifYes = (answer) => answer?.answer === "yes";
  const ifNo = (answer) => answer?.answer === "no";

  const onDragEnd = (e, setDragState) => {
    setDragState();

    if (!inYes && !inNo) return;

    if (inYes) {
      setCurrentAnswer({
        answer: "yes",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    } else if (inNo) {
      setCurrentAnswer({
        answer: "no",
        imgSrc: currentQuestion.icon,
        title: currentQuestion.title,
        desc: currentQuestion.desc,
      });
    }

    setAnswered(true);
    setInYes(false);
    setInNo(false);
  };

  const getAnswers = (ans) => {
    return filter(answers, { answer: ans });
  }

  return (
    <Grid>
      <Grid container alignItems="center" justify="flex-start">
        <Grid>
          <Typography variant="h4" className={classes.includedTitle}>
            INCLUDED IN U.S. GDP?
          </Typography>
        </Grid>
        <DraggableAnswer
          showDraggable={!answered}
          onDragStart={onDragStart}
          onDragEnd={(e) => onDragEnd(e, () => setDragStarted(false))}
          onDragUpdate={onDragUpdate}
          currentQuestion={currentQuestion}
          dragStarted={dragChildStarted}
        />
      </Grid>
      <Grid className={classes.dropImageContainer}>
        {showDropIconSection && !dragStarted && (
          <Grid container justify="center">
            {answered ? (
              <Button
                // style={{ animationDuration: "1.5s" }}
                className={`${classes.submitButton
                  } animate__animated animate__bounceIn`}
                onClick={() => {
                  setAnsweredCorrectly(currentAnswer.answer === currentQuestion.answer)
                  onSubmit(currentAnswer)
                }}
              >
                Confirm Answer
              </Button>
            ) : (
              <img
                src={dropImage}
                className={`${
                  classes.dropImageStyle
                } animate__animated animate__bounceIn`}
              />
            )}
          </Grid>
        )}
      </Grid>

      <Grid container justify="space-between">
        <GDPDroppable
          aref={yesRef}
          title="yes"
          inAnswer={inYes}
          ifAnswer={ifYes}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          setAnswered={setAnswered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "no" && answeredCorrectly === false}
        />

        <GDPDroppable
          aref={noRef}
          title="no"
          inAnswer={inNo}
          ifAnswer={ifNo}
          currentAnswer={currentAnswer}
          getAnswers={getAnswers}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragUpdate={onDragUpdate}
          setAnswered={setAnswered}
          dragStarted={dragChildStarted}
          setDragStarted={setDragChildStarted}
          showAnimation={prevAnswer?.answer === "yes" && answeredCorrectly === false}
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PlayQuiz);
